import React, { useState } from 'react';
import {
  Badge,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@roger/ui-components';

/**
 * Shared outline “E” mark used after a status pill on visit/task rows
 * (Episode Manager, Hotbox, EOE preview, …).
 */
export const ExternalEmrLetterMark: React.FC<{
  tooltip: string;
  testId: string;
}> = ({ tooltip, testId }) => {
  const [open, setOpen] = useState(false);

  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <span
            role='button'
            tabIndex={0}
            aria-label={`E. ${tooltip}`}
            className='inline-flex shrink-0 cursor-help'
            onClick={event => {
              event.stopPropagation();
              setOpen(true);
            }}
            onKeyDown={event => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                event.stopPropagation();
                setOpen(true);
              }
            }}
            data-testid={testId}
          >
            <Badge
              variant='outline'
              className='whitespace-nowrap px-1.5 py-0 text-[10px] font-medium text-muted-foreground'
            >
              E
            </Badge>
          </span>
        </TooltipTrigger>
        <TooltipContent className='max-w-xs'>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
